<template>
  <ev-tabs :options="{ contentClass: 'main-content', tabClass: 'tab-links-nested tab-link-people' }">
    <ev-tab
      :name="`My ${groupTerminology}`"
      id="tab-people-table"
      user-list-type="TABLE"
      class="tab-people people-table"
    >
      <div class="content-title search">
        <div class="filter-az">
          <person-list-filter v-model="filters"></person-list-filter>
        </div>
      </div>
      <div class="content-title">
        <div v-if="userTable.LOGO" class="panel-logo"><img :src="userTable.LOGO" alt="userTable.TITLE" /></div>
        <div v-if="!userTable.LOGO" class="panel-icon"><i class="ar-icon icon-ico_table_users"></i></div>
        <div v-if="!userTable.LOGO || userTable.SHOW_TITLE" class="panel-name">{{ userTable.TITLE }}</div>
      </div>
      <div class="content-body">
        <div class="body-meta clearfix">
          <div class="meta-info">
            <template v-if="userTable.TABLE_TYPE === 'PublicGallery'">
              <ul class="message-public">
                <li>You have been placed in the public gallery as you logged in using a public email address</li>
                <li>You still have full access to view the event presentation and browse the room</li>
                <li>Video Chat, Private Chat and {{ groupTerminology }} Chat are disabled</li>
                <li>To access all room features please login with your work professional email address</li>
              </ul>
            </template>
            <template v-else>
              <div class="message-private">
                This is your {{ groupTerminology.toLowerCase() }} and these are your fellow guests.
                <ul>
                  <li>
                    You can group chat privately to all of them via
                    <a
                      href="javascript:void(0);"
                      class="nodecoration"
                      @click="openTabs(['#tab-chat', '#tab-chat-table'])"
                      >Chat > {{ groupTerminology }}
                    </a>
                  </li>
                  <li>
                    Chat individually using the chat bubble
                    <i aria-hidden="true" class="  ar-icon user_in icon-comment-alt-light"></i> next to their name.
                  </li>
                  <li v-if="videoChatEnabled">
                    When available use the video icon
                    <i aria-hidden="true" class="  ar-icon user_in icon-video-light"></i> to initiate a video chat.
                  </li>
                </ul>
              </div>
            </template>
          </div>
        </div>
        <div class="my-guests">
          <div :id="'TABLE_' + userTable.uuid" class="my-table">
            <div class="guests">
              <ul class="guest-list rows">
                <li class="guest" v-for="user in filteredTableUsers" :key="'myTableUser-' + user.userUUID">
                  <person
                    :person="user"
                    :options="{ company: true, title: true, actions: true, inlineActions: true }"
                  ></person>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </ev-tab>
    <ev-tab
      name="Contacts"
      id="tab-people-network"
      v-if="isNetworkingAllowed"
      user-list-type="CONTACTS"
      class="tab-people people-network"
    >
      <div class="content-title search">
        <div class="filter-az">
          <person-list-filter v-model="filters"></person-list-filter>
        </div>
      </div>
      <div class="content-body">
        <div class="body-meta">
          <div class="meta-info network">
            <div class="meta-ico"><i class="ar-icon icon-check-circle-light" aria-hidden="true"></i></div>
            <div class="meta-data">
              <p>
                These are people with whom you have had a personal conversation or have added to your contacts and are
                identified by the checkmark <i class="ar-icon icon-check-circle-light user_in" aria-hidden="true"></i>.
              </p>
              <ul>
                <li>
                  Click the chat bubble <i aria-hidden="true" class="  ar-icon user_in icon-comment-alt-light"></i> to
                  start or continue personal conversations.
                </li>
                <li v-if="videoChatEnabled">
                  Use the video icon <i aria-hidden="true" class="  ar-icon user_in icon-video-light"></i> when
                  available to initiate a video chat.
                </li>
                <li>For convenience you can make people inactive and restore them as required.</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="tabs-network">
          <a
            href="javascript:void(0);"
            class="tab-net"
            :class="{ 'is-active': showActiveNetworkUsers }"
            @click="showActiveNetworkUsers = true"
            ><i class="ar-icon icon-check-circle-light"></i> Active</a
          >
          <a
            href="javascript:void(0);"
            class="tab-net"
            :class="{ 'is-active': !showActiveNetworkUsers }"
            @click="showActiveNetworkUsers = false"
            ><i class="ar-icon icon-times-circle-light"></i> Inactive</a
          >
        </div>
        <div class="user-connections">
          <ul class="guest-list rows">
            <li class="guest" v-for="user in filteredNetworkUsers" :key="'myNetworkUser-' + user.userUUID">
              <person
                :person="user"
                :options="{ company: true, title: true, actions: true, inlineActions: true, networkRestore: true }"
              ></person>
            </li>

            <li v-if="!filteredNetworkUsers.length" style="text-align: center">
              Nothing to show
            </li>
          </ul>
        </div>
      </div>
    </ev-tab>
    <ev-tab name="Everyone" id="tab-people-room" user-list-type="ROOM" class="tab-people people-room">
      <div class="content-body">
        <div class="content-title search">
          <div class="search-group">
            <div class="search-box">
              <input type="text" class="form-control" placeholder="Search..." v-model="searchQuery" />
            </div>
            <div class="search-ico"><i aria-hidden="true" class="ar-icon icon-search-light"></i></div>
          </div>
          <div class="filter-az">
            <div class="list-az">
              <button
                v-for="filterItem in alphabetFilters"
                :key="filterItem"
                :class="[
                  filterItem === activeAlphabetFilter
                    ? 'btn-primary'
                    : getAlphabetUsers(filterItem).length
                    ? 'btn-default'
                    : 'btn-disabled'
                ]"
                class="btn btn-sm"
                @click="activeAlphabetFilter = filterItem"
                :disabled="!getAlphabetUsers(filterItem).length"
              >
                {{ filterItem.toUpperCase() }}
              </button>
            </div>
            <person-list-filter v-model="filters" showRoomsFilter></person-list-filter>
          </div>
        </div>
        <ul class="guest-list rows">
          <li class="guest" v-for="user in filteredRoomUsers" :key="'roomUser-' + user.userUUID">
            <person :person="user" :options="{ actions: true, inlineActions: true }"></person>
          </li>
          <li v-if="showLoadMoreButton" class="usr-load-more">
            <a href="javascript:void(0);" @click="loadMoreUsers">
              <i class="fa fa-chevron-down" aria-hidden="true"></i>
              <span> load more </span>
              <i class="fa fa-chevron-down" aria-hidden="true"></i>
            </a>
          </li>
        </ul>
      </div>
    </ev-tab>
  </ev-tabs>
</template>

<script>
import Tabs from "@/components/DigitalEvent/common/Tabs";
import Tab from "@/components/DigitalEvent/common/Tab";
import Person from "./People/Person";
import { CHAT_MODES, USER_CONNECTIONS_STATUSES, TABLE_TYPES } from "@/helpers/constants";
import { scrollToTheBottom } from "@/helpers/DOMHelper";
import UsersSearchMixin from "@/components/DigitalEvent/RoomList/Room/mixins/UsersSearchMixin";
import { mapGetters, mapState } from "vuex";
import PersonListFilter from "@/components/DigitalEvent/RoomList/Room/People/PersonListFilter";

export default {
  name: "People",
  mixins: [UsersSearchMixin],
  components: {
    "ev-tabs": Tabs,
    "ev-tab": Tab,
    person: Person,
    "person-list-filter": PersonListFilter
  },
  data() {
    return {
      showActiveNetworkUsers: true,
      USER_LIST_TYPE: null
    };
  },
  computed: {
    ...mapGetters({
      userTable: "tables/userTable",
      groupTerminology: "room/groupTerminology",
      videoChatEnabled: "videoChat/videoChatEnabled"
    }),
    ...mapState("users", {
      user: "user",
      connections: "userConnections",
      currentUser: "user"
    }),
    ...mapState("chat", {
      unreadMessagesCounter: "unreadMessagesCounter",
      isFilterActive: "privateChatTarget"
    }),
    isNetworkingAllowed() {
      return this.$store.getters["tables/userTable"].TABLE_TYPE !== TABLE_TYPES.PUBLIC_GALLERY;
    },
    tableUsers() {
      return this.$store.getters["tables/tableUsers"](this.userTable.uuid);
    },
    activeUsers() {
      return this.tableUsers.filter(u => u.isOnline).length;
    },
    inactiveUsers() {
      return this.tableUsers.filter(u => !u.isOnline).length;
    },
    tableMessagesCount() {
      return this.$store.state.chat.tableMessages.length;
    },
    privateMessagesCount() {
      return this.$store.getters["chat/privateMessages"].length;
    },
    chatMode: {
      get() {
        return this.$store.state.chat.chatMode;
      },
      set(value) {
        this.$store.commit("chat/changeChatMode", {
          mode: value,
          scrollPage: false
        });

        this.$store.commit("chat/resetUnreadMessagesCounter");

        if (value === CHAT_MODES.PRIVATE) {
          this.$store.commit("chat/setPrivateChatTarget", null);
          scrollToTheBottom("privateMessages");
        } else {
          scrollToTheBottom(`group-${this.userTable.uuid}-messages`);
        }
      }
    },
    /**
     * Users list based on current tab
     * TODO: move user list to separate component
     * @return {Object[]}
     * @private
     */
    _users() {
      let users;
      switch (this.USER_LIST_TYPE) {
        case "ROOM":
          users = Object.values(this.$store.state.room.deState).flat();
          break;
        case "CONTACTS":
          users = this.$store.state.users.userConnections
            .filter(connection => {
              return (
                connection.connectionStatus ===
                (this.showActiveNetworkUsers ? USER_CONNECTIONS_STATUSES.ACTIVE : USER_CONNECTIONS_STATUSES.INACTIVE)
              );
            })
            .map(connection => {
              return this.getUser(connection);
            });
          break;
        case "TABLE":
          users = this.tableUsers;
          break;
        default:
          users = [];
      }
      return users;
    },
    /** Filtered and paged list of room users */
    filteredRoomUsers() {
      return this._pagedResult;
    },
    /** Filtered list of contacts users */
    filteredNetworkUsers() {
      return this._usersResult;
    },
    /** Filtered list of table users */
    filteredTableUsers() {
      return this._usersResult;
    }
  },
  methods: {
    clearFilter() {
      this.$store.commit("chat/setPrivateChatTarget", null);
    },
    isCurrentUser(user) {
      return this.currentUser.user_uuid === user.userUUID;
    },
    getUser(connection) {
      return this.$store.getters["users/getUser"](connection.targetUserUUID);
    },
    openTabs(tabNames, doScroll) {
      tabNames.forEach((tab, index) => {
        setTimeout(() => {
          this.$root.$emit("activateTab", tab);
        }, 300 * index);
      });

      if (doScroll) {
        this.$scrollTo("#people-chat-container");
      }
    }
  },
  created() {
    this.$store.dispatch("users/getUserConnections");
    this.$root.$on("setUserListType", type => {
      this.USER_LIST_TYPE = type;
      this._setDefaultFilters({ isOnline: type === "ROOM" }, type);
    });
  },
  destroyed() {
    this.$root.$off("setUserListType");
  }
};
</script>
